import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const ACTING_KEY = "qrf_acting_rid";

api.interceptors.request.use((config) => {
  const rid = localStorage.getItem(ACTING_KEY);
  if (rid) config.headers["X-Restaurant-Id"] = rid;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && /^\/(my|platform)\//.test(url) && window.location.pathname.startsWith("/admin")) {
      localStorage.removeItem(ACTING_KEY);
      window.location.replace("/login");
    }
    return Promise.reject(err);
  }
);

export function fileUrl(path) {
  if (!path) return null;
  return `${API}/files/${path}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
